import { FunctionComponent } from "react";

import { ProgressSpinner } from "primereact/progressspinner";

import "./LoadingPage.scss";

interface ILoadingPageProps {
  loadingInformation?: string;
}

export const LoadingPage: FunctionComponent<ILoadingPageProps> = (props: ILoadingPageProps) => {
  const loadingInformation = props.loadingInformation?.length ? props.loadingInformation : "Loading page ...";

  return (
    <div className="page-loading">
      <ProgressSpinner />

      {!!loadingInformation && <span>{loadingInformation}</span>}
    </div>
  );
};
